/** AppInstance 逻辑 field key（供 accessPolicy / assertPluginLayout） */
export const APP_INSTANCE_FIELD_KEYS = [
  'base.name',
  'base.description',
  'base.workspace',
  'app.runtime.type',
  'app.runtime.workload',
  'app.framework',
  'app.inferenceSystem',
  'app.inferenceService',
  'app.commonEnv',
  'app.healthCheck',
  'app.runMode',
  'app.masterNodes',
  'app.workerNodes',
  'app.appStorageGroups',
  'app.dataMountPath',
] as const;

export type AppInstanceFieldKey = (typeof APP_INSTANCE_FIELD_KEYS)[number];
